import {
  ArticlesByCategoryTemplate,
  ArticlesByCategoryTemplateProps,
} from '@/components/template/ArticlesByCategoryTemplate';
import { mapBlogResponseToBlogPreview } from '@/lib/blog';
import { getBlogPosts } from '@/services/wordpress/articles';
import { getCategories } from '@/services/wordpress/categories';
import { RawBlogType } from '@/types/blog';
import { BasePageProps } from '@/types/page';
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from 'next';
import { ParsedUrlQuery } from 'querystring';

export const getStaticProps: GetStaticProps<
  ArticlesByCategoryTemplateProps,
  ParsedUrlQuery
> = async (context) => {
  const { slug } = context.params || {};
  if (typeof slug !== 'string') {
    return {
      notFound: true,
      revalidate: 1,
    };
  }

  const [mainCategory] = await getCategories({
    fields: ['id', 'name', 'slug'],
    slug,
  });

  if (!mainCategory) {
    return {
      notFound: true,
      revalidate: 1,
    };
  }

  const [remainingCategories, blogPostsByCategoryResponse] = await Promise.all([
    getCategories({
      fields: ['id', 'slug', 'name'],
      exclude: [mainCategory.id],
    }),
    getBlogPosts({
      fields: ['id', 'title', 'excerpt', 'slug'],
      getCategoriesAndFeaturedImage: true,
      categories: [mainCategory.id],
      per_page: 5,
    }),
  ]);

  // TODO: NOEC-76
  const rawArticles: RawBlogType[] = await blogPostsByCategoryResponse.json();

  const maxPages = Number(
    blogPostsByCategoryResponse?.headers?.get('x-wp-totalpages')
  );

  return {
    props: {
      mainCategory,
      categories: [mainCategory, ...remainingCategories],
      maxPages,
      articles: mapBlogResponseToBlogPreview(rawArticles),
      metadata: {
        title: `${mainCategory.name} | EV.com`,
        description: `${mainCategory.name} | EV.com`,
      },
    } satisfies BasePageProps<ArticlesByCategoryTemplateProps>,
    revalidate: 100,
  };
};

export default function Blog(
  props: InferGetStaticPropsType<typeof getStaticProps>
) {
  return (
    <main>
      <ArticlesByCategoryTemplate {...props} />
    </main>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
